module.exports = __webpack_public_path__ + "img/bugoro_01.acdb726c.png";